import React,{ useRef } from 'react';
import axios from 'axios'
import { Table,Tabs, Input, Button,Collapse,Tooltip,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles
import IncomeStatementsView_f1 from './IncomeStatementsView_f1';
import BalanceSheetDateRangeView_fr1 from './BalanceSheetDateRangeView_fr1';
import CashFlowReportView_fr1 from './CashFlowReportView_fr1';
import ReserveReportView from './ReserveReportView';


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { TabPane } = Tabs;

var token= ''
var sacco= ''
var bizuserid= ''


class FinancialStatementsView extends React.Component {

  state = {
   datarequested:false,
   ledeger_details_model_visible:false,
  };

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }
    
    this.setState({datarequested:false})

  }




  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {
      
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>

              <Tabs defaultActiveKey="1" onChange={()=>{}}>
                 
                  <TabPane tab="Statement Of Profit Or Loss" key="001" >
                    <IncomeStatementsView_f1 />

                  </TabPane>


                  <TabPane tab="Statement Of Financial Position" key="002" >
                    <BalanceSheetDateRangeView_fr1 />
                   </TabPane>


                   <TabPane tab="Statement of Changes in Reserve" key="003" >
                    <ReserveReportView />
                   </TabPane>


                   <TabPane tab="Statement Of CashFlows" key="004" >
                    <CashFlowReportView_fr1 />
                   </TabPane>

                   
             </Tabs>
     
        </div>
    )}
    
  }
}

export default FinancialStatementsView; 
